module.exports = __webpack_public_path__ + "resources/images/screen6-f065efa4d88be8c18e11777d3b5cb90c-cache.png";